import { IDestroyOptions } from "@pixi/display";
import { PlayerModel } from "../../../../models/player/PlayerModel";
import { GameViewController } from "../../../../controllers/GameViewController";
import { ScaleUpCallableAnimationButton } from "../../../../../common/components/buttons/ScaleUpCallableAnimationButton";
import { GameModel } from "../../../../models/game/GameModel";
import { AudioManager } from "../../../../../../audio/AudioManager";
import { Sprite } from "@pixi/sprite";
import { BaseBoosterButton } from "./BaseBoosterButton";
import { GameUIResourcesPackage } from "../../../../../preloader/resources/GameUIResourcesPackage";

export class EraseBoosterButton extends BaseBoosterButton {
    public readonly button: ScaleUpCallableAnimationButton;
    private readonly adButton: ScaleUpCallableAnimationButton;

    public constructor(
        private readonly playerModel: PlayerModel,
        private readonly gameModel: GameModel,
        private readonly gameViewController: GameViewController,
        private readonly audioManager: AudioManager,
        resources: GameUIResourcesPackage
    ) {
        super(resources);
        this.button = new ScaleUpCallableAnimationButton({
            defaultTexture: resources.assets_game_button_substrate_purpure_png
        }, this.audioManager);
        const icon = this.button.addChild(new Sprite(resources.assets_game_button_icon_erase_png));
        icon.position.set((this.button.width - icon.width) * 0.5, 17);
        this.adButton = new ScaleUpCallableAnimationButton({
            defaultTexture: resources.assets_game_ad_play_btn_png
        }, audioManager);
        this.addChild(this.button);
        this.addChild(this.adButton);
        this.adButton.visible = false;
        this.adButton.position.set(90, 90);
        this.button.onUp.add(this.handleEraseButtonClick, this);
        this.adButton.onUp.add(this.handleEraseButtonClick, this);
        this.playerModel.propertyChanged.add(this.redrawCount, this);
        this.gameModel.onGameOver.add(this.handleGameOver, this);
        this.redrawCount();
    }

    private async handleEraseButtonClick(): Promise<void> {
        this.button.enabled = false;
        if (this.playerModel.eraseBooster.value > 0){
            this.visible = false;
            this.gameViewController.showBonusFigure();
        } else {
            const result = await this.gameViewController.showAdForBonusFigure();
            if(result) {
                this.adButton.visible = false;
            }
        }
        this.button.enabled = true;
    }

    private redrawCount(): void {
        if (this.playerModel.eraseBooster.value == 0) {
            this.adButton.visible = true;
        } else {
            this.adButton.visible = false;
        }
    }

    private handleGameOver(isHaveShuffles: boolean): void {
        if (isHaveShuffles) {
            this.button.playAnimation();
        }
        else {
            this.button.stopAnimation();
        }
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.playerModel.onChanged.remove(this.redrawCount, this);
        this.button.onUp.remove(this.handleEraseButtonClick, this);
        this.gameModel.onGameOver.remove(this.handleGameOver, this);
        super.destroy(options);
    }
}